// Helper for navigating to external (non-React) URLs
export function goToExternal(path, newTab = false) {
  if (newTab) {
    window.open(path, '_blank');
  } else {
    // assign preserves history; replace would not
    window.location.assign(path);
  }
}

export default goToExternal;
